module.exports = __webpack_public_path__ + "img/tabBg3.7ef401d3.jpg";